import platforms from '../../constants/platforms';

const { TWITCH, YOUTUBE } = platforms;

export function getFeaturePolicies(platform) {
  const featurePolicies = {
    [TWITCH]: ['fullscreen'],
    [YOUTUBE]: [
      'accelerometer',
      'autoplay',
      'encrypted-media',
      'fullscreen',
      'gyroscope',
      'picture-in-picture'
    ]
  };
  return (featurePolicies[platform] || []).join('; ');
}
